export default "__VITE_ASSET__dc9304a2__"